import type { CounterpartyTypeEnum, ModeEnum } from './types';

export class Customer {
  CounterpartyID!: number;
  DisplayName!: string;
  Name!: string;
  Type!: (typeof CounterpartyTypeEnum)['Customer'];
  /** PricingRuleMode is sometimes injected server-side, for Customer objects */
  PricingRuleMode?: ModeEnum;

  constructor(data: Customer) {
    Object.assign(this, data);
  }
}
